var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"list"},_vm._l((_vm.members),function(member){return _c('TeamCard',{key:member.id,attrs:{"member":member}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }